var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doc-detail"},[(_vm.doc)?_c('markdown',{attrs:{"source":_vm.doc.content}}):_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"article"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }